import { useSelector } from 'react-redux';
import { checkPrimaryUser, checkReadOnlyUser } from '../redux/auth/auth.selectors';

// =============================================================================
// SIMPLIFIED PERMISSION HOOKS
// =============================================================================

// User role hooks - these are the only ones we need now
export const useIsPrimaryUser = () => useSelector(checkPrimaryUser);
export const useIsReadOnly = () => useSelector(checkReadOnlyUser);

// Composite permission hooks using the simplified logic
// All permissions now follow the same rule: isPrimaryUser || (!isPrimaryUser && !isReadOnly)
export const useCanSign = () => {
  const isPrimaryUser = useIsPrimaryUser();
  const isReadOnly = useIsReadOnly();
  return isPrimaryUser || (!isPrimaryUser && !isReadOnly);
};

export const useIsAdmin = () => {
  const isPrimaryUser = useIsPrimaryUser();
  const isReadOnly = useIsReadOnly();
  return isPrimaryUser || (!isPrimaryUser && !isReadOnly);
};

export const useCanManageDocuments = () => {
  const isPrimaryUser = useIsPrimaryUser();
  const isReadOnly = useIsReadOnly();
  return isPrimaryUser || (!isPrimaryUser && !isReadOnly);
};

export const useHasFinancialAccess = () => {
  const isPrimaryUser = useIsPrimaryUser();
  const isReadOnly = useIsReadOnly();
  return isPrimaryUser || (!isPrimaryUser && !isReadOnly);
};